var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#EAECF6",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9871 8.69763H12.0133C11.2874 8.70494 10.5938 8.99915 10.0841 9.51603C9.57428 10.0329 9.28971 10.7305 9.29245 11.4564V27.3596C9.28966 28.0856 9.57422 28.7833 10.084 29.3001C10.5938 29.817 11.2874 30.1112 12.0134 30.1185H27.9872C28.714 30.1135 29.4091 29.8201 29.9197 29.3028C30.4303 28.7854 30.7145 28.0865 30.7099 27.3596V11.4513C30.7145 10.7245 30.4303 10.0255 29.9198 9.50809C29.4092 8.99071 28.714 8.69729 27.9871 8.69235",
    fill: "#9F1A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9871 30.3927H12.0133C11.2124 30.3877 10.4461 30.0652 9.88268 29.4959C9.31924 28.9266 9.00462 28.1571 9.00784 27.3562V11.4513C9.00416 10.6501 9.31858 9.88012 9.88207 9.31049C10.4456 8.74085 11.2121 8.4181 12.0133 8.41309H27.9871C28.7883 8.41811 29.5548 8.74087 30.1183 9.31051C30.6818 9.88014 30.9962 10.6501 30.9925 11.4513V27.3544C30.9958 28.1554 30.6811 28.9249 30.1177 29.4942C29.5543 30.0634 28.788 30.3859 27.9871 30.3909M12.0133 8.98043C11.3625 8.98544 10.7403 9.24842 10.2832 9.71165C9.82612 10.1749 9.57146 10.8006 9.57513 11.4513V27.3544C9.57149 28.0052 9.82616 28.6309 10.2833 29.0941C10.7403 29.5573 11.3625 29.8203 12.0133 29.8254H27.9871C28.6378 29.8203 29.26 29.5573 29.7171 29.0941C30.1742 28.6309 30.4289 28.0052 30.4252 27.3544V11.4513C30.4284 10.8007 30.1736 10.1753 29.7166 9.71219C29.2596 9.24905 28.6377 8.9859 27.9871 8.98037L12.0133 8.98043Z",
    fill: "#9F1A45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1332 13.1278C20.7847 13.138 21.4186 13.3405 21.9553 13.7098C22.492 14.0792 22.9077 14.5989 23.1499 15.2037C23.3922 15.8085 23.4503 16.4715 23.317 17.1092C23.1837 17.747 22.8649 18.3311 22.4006 18.7882C21.9363 19.2453 21.3473 19.5551 20.7076 19.6785C20.0679 19.8019 19.4059 19.7335 18.8049 19.4819C18.2039 19.2302 17.6907 18.8066 17.3297 18.2642C16.9687 17.7218 16.7761 17.0849 16.776 16.4333C16.779 15.9957 16.8682 15.563 17.0386 15.1599C17.209 14.7568 17.4572 14.3913 17.769 14.0842C18.0808 13.7772 18.4502 13.5347 18.8559 13.3706C19.2615 13.2065 19.6956 13.1239 20.1332 13.1278ZM24.0181 11.4949H27.9184V27.3187H24.0163V22.8355C20.5816 24.0908 17.3709 24.2012 14.4172 21.3112C13.1964 20.0405 12.5084 18.3076 12.7964 15.2866C12.8464 14.8245 12.6239 12.6812 12.086 11.4931H15.5432C17.1658 14.0692 15.038 17.3557 17.5244 19.4559C20.9109 21.6492 23.8664 19.0266 24.0094 16.6591L24.0181 11.4949Z",
    fill: "#FEBD30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnb);
export default __webpack_public_path__ + "static/media/PNB.2698d45a57e1789932bc6bd8cc65acce.svg";
export { ForwardRef as ReactComponent };